import { createFileRoute } from "@tanstack/react-router";
import { McpClients } from "../../../features/connections/mcp-clients";

export const Route = createFileRoute("/_authed/$org/integrations/mcp")({
  validateSearch: (s: Record<string, unknown>): { focus?: string } => (typeof s.focus === "string" ? { focus: s.focus } : {}),
  component: McpPage,
});

function McpPage() {
  const { org } = Route.useParams();
  const { focus } = Route.useSearch();
  return <McpClients org={org} {...(focus ? { focus } : {})} />;
}
